import moduleIntegrityCheck from "~components/shared/module/Module.integrity";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

import type { PosterDefaultProps } from "./PosterDefault";

export default function integrityCheck(
    props: PosterDefaultProps
): IntegrityStatus {
    const messages: IntegrityStatus = moduleIntegrityCheck(props);

    if (!props.image) messages.push("Missing module image");
    else if (!props.image.baseUrl) messages.push("Invalid image baseUrl");

    return messages;
}
